import { makeStyles, Theme, createStyles } from "@mui/styles";
import { cloneDeep } from "lodash";
import * as React from 'react';
import {Typography} from '@mui/material';
import {FormControl, FormControlLabel, FormHelperText} from '@mui/material';
import {Switch} from '@mui/material';
import {Grid} from '@mui/material';
import { useContext } from "react";
import {DataContext} from "~common/form/icg-definition-data-provider";
import PortalUserContext, {FeatureArea} from '~common/lib/portal-user-context';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
        width: '100%'
      },
      formControl: {
        width: '100%'
      },
      featureAreaHeading: {
        fontWeight: 600
      },
      featureAreaSubheading: {
        //paddingLeft: -15,
        //paddingRight: -15
      },
      featureGrid: {
        //paddingLeft: 30,
        //paddingRight: 30
      },
      root: {
        width: '100%'
      },
      formField: {
        width: '100%'
      },
      toolbar: {
        justifyContent: 'flex-end'
      },
      headerPaper: {
        padding: 30
      },
      userList: {
        // height: 300,
        // overflow: 'auto'
      },
      dangerButton: {
        backgroundColor: '#af0202',
        marginLeft: 10,
        '&:hover': {
          backgroundColor: '#5D0A0A !important'
        }
      }
  })
);

interface Props {
  fieldDefinition: any;
  policyMessages?: any;
  readOnlyOverride?: boolean;
}


export const GroupFeatureRelationList: React.FC<Props> = ({
  value,
  onCommitChange
}) => {
    
    const classes = useStyles();    
    
    const featureAreas = PortalUserContext.featureAreas;

    const [fullData, setFullData] = useContext(DataContext);

    var featureAssignments = {};
    if (value && value.relations) {
        for (let i = 0; i < value.relations.length; i++) {
            const relation = value.relations[i];
            const feature = relation.value;
            featureAssignments[feature.key] = relation;
        }
    }

    var group = cloneDeep(fullData)

    const handleFeatureSwitchChange = (featureKey: string) => (event: any) => {
        const checked = event.target.checked;
            if (featureKey) {
                if (!checked) {
                    delete featureAssignments[featureKey];
                } else {
                    const uf = findUserFeature(featureKey);
                    var rel = {};
                    rel['label'] = uf.title;
                    rel['value'] = uf;
                    featureAssignments[featureKey] = rel;
                }
        }


        const relations = Object.keys(featureAssignments).map((i: any)=>{
            return featureAssignments[i]
        })

        var data = {
            relations: {}
        }

        if (value) {
            data = value
        }

        if (data && data.relations) {
            data.relations = relations;
        } 
        

        if (onCommitChange) {
            onCommitChange(data);
        }
    }

    const findUserFeature = (key: string) => {
        for (var fa = 0; fa < featureAreas.length; fa++) {
            const featureArea = featureAreas[fa];
            for (var f = 0; f < featureArea.features.length; f++) {
                const feature = featureArea.features[f];
                if (feature.key == key) {
                    return feature;
                }
            }
        }
    }

    var sidx = 0;
    const featureAreasViews = featureAreas.map(
      (fa: FeatureArea, idx: number) => {
        var subAreas: any = {};

        // We will start off by converting the available feature areas into a suitable structure for rendering the areas.
        fa.features.forEach((f) => {
          // The features that we should display should be limited to
          // * If the restrictToUserType for the group is null, allow all features where requireAssignment is true.
          // * Otherwise, only show features where
          //     * feature.requireAssignment is true
          //     * feature.restrictToUserType is falsy or matches the group restrictToUserType
          if (f.requireAssignment) {
            if (
              (!group.groupInfo.restrictToUserType) ||
              !f.restrictToUserType ||
              f.restrictToUserType == group.groupInfo.restrictToUserType
            ) {
              var key = f.subAreaTitle ? f.subAreaTitle : 'none';
              if (!subAreas[key]) {
                subAreas[key] = {
                  title: f.subAreaTitle,
                  features: new Array<any>()
                };
              }

              subAreas[key].features.push(f);
            }
          }
        });

        let sal = new Array<any>();
        for (let key in subAreas) {
          sidx += 1;
          var sa = subAreas[key];
          var fidx = 0;
          let fl = sa.features.map((f: any, idx: number) => {
            // console.log('sdfsfd', f);
            fidx += 1;
            let chk =
              featureAssignments[f.key] != undefined &&
              featureAssignments[f.key] != null;
            return (
              <Grid
                key={'sa' + sidx + 'f' + fidx}
                item
                lg={3}
                md={4}
                sm={6}
                xs={12}>
                <FormControl className={classes.formControl}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={chk}
                        onChange={handleFeatureSwitchChange(f.key)}
                      />
                    }
                    label={f.title}
                  />
                </FormControl>
              </Grid>
            );
          });

          if (sa.title) {
            sal.push(
              <Grid key={'sa' + sidx} item xs={12}>
                <Typography
                  variant="subtitle1"
                  className={classes.featureAreaSubheading}
                  gutterBottom>
                  {sa.title}
                </Typography>
              </Grid>
            );
          }

          sal.push(fl);
        }

        // If a subarea has no items, no need to render it at all.
        if (sal.length == 0) {
          return null;
        }

        // console.log('sal', sal);

        return [
          <Grid key={'sa' + sidx} item xs={12}>
            <Typography
              key={'fa' + idx}
              variant="subtitle1"
              className={classes.featureAreaHeading}
              gutterBottom>
              {fa.title}
            </Typography>
          </Grid>,
          sal
        ];
      }
    );

    return (
        <div className={classes.container}>
          <Grid container>{featureAreasViews}</Grid>
        </div>
      );
};

export default GroupFeatureRelationList;
